import React from "react";
import "./LotoreyaCard.css";

const LotoreyaCard = ({ image, title, value, price, date, sold, onImageClick, onBuyClick, disabled, winnerUser }) => {
  return (
    <div className="lottery-card">
      <div className="lottery-top">
        <div className="lottery-value">
          Gerçək Dəyəri:
          <span className="highlight"> {value}</span>
        </div>
        <div
          className="lottery-image"
          onClick={onImageClick}
          style={{ cursor: 'pointer' }}
        >
          <img src={image} alt={title} />
          <div className="ticket-count">1 ədəd</div>
        </div>
      </div>

      <div className="lottery-status">
        {sold >= 100 ? "❌ Satılıb" : "Tükənir.."}
      </div>

      <div className="lottery-details">
        <div className="title">
          <b>{title}</b>
          <span className="price">{price}</span>
        </div>
        <div className="draw-date">
          📅 Lotoreya Keçirilmə Tarixi: {date}
        </div>
        <div className="progress-text">Satılan: {sold}%</div>
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: `${sold}%` }}
          ></div>
        </div>

        {winnerUser ? (
          <div
            className="winner-box"
            style={{
              backgroundColor: '#f9f9f9',
              padding: '12px',
              borderRadius: '8px',
              border: '2px solid green',
              textAlign: 'center',
              marginTop: '12px',
              fontWeight: 'bold',
              color: 'green',
            }}
          >
            ✅ Lotoreya başa çatıb <br />
            👤 Qalib: <span style={{ color: '#2c3e50' }}>{winnerUser}</span>
          </div>
        ) : (
          <button
            className="buy-button"
            onClick={onBuyClick}
            disabled={disabled}
            style={{
              backgroundColor: disabled ? '#ccc' : '#fff',
              cursor: disabled ? 'not-allowed' : 'pointer',
            }}
          >
            {disabled ? "❌ Satılıb" : "🎟️ Bilet Al"}
          </button>
        )}

      </div>
    </div>
  );
};

export default LotoreyaCard;

